import React from 'react'
import './event-comment-skeleton.css'

function EventCommentSkeleton() {
  return (
    <div className="event-comment-skeleton" />
  )
}

export default EventCommentSkeleton